<div class="login-header" [class.bottom-border]="addBotBorder" id="account-pencil-header">
  <a (click)="goToLogin()">
    <svg-icon
      *ngIf="showLogo && !institutionLogo && !logoIsLoading"
      class="top-left-logo"
      width="211"
      height="30"
      [icon]="'pencil-spaces-2'"
    ></svg-icon>
    <img
      *ngIf="institutionLogo && showLogo"
      [src]="institutionLogo"
      alt="institution logo"
      height="30"
    />
  </a>
  <div class="float-right link-right d-flex align-items-center">
    <a *ngIf="showLogout" (click)="signOut()" class="button-link">
      {{ 'Sign out' | translate }}
    </a>
    <button mat-button [matMenuTriggerFor]="langMenu" class="btn-lang-select cml-16 pr-1">
      <span> {{ this.displayLangName | translate }} </span>
      <mat-icon class="cml-16">expand_more</mat-icon>
    </button>
  </div>
</div>

<mat-menu #langMenu="matMenu" class="lang-menu">
  <div *ngFor="let lang of langCodeList">
    <button
      mat-menu-item
      [ngStyle]="
        currentSelectedLanguage?.code === lang.code
          ? { 'background-color': '#cce7ff', color: '#0f42c8' }
          : ''
      "
      (click)="changeLang(lang, true)"
    >
      {{ lang.originalLabel }} / {{ lang.label | translate }}
      <mat-icon *ngIf="currentSelectedLanguage?.code === lang.code" class="check-icon"
        >check
      </mat-icon>
    </button>
  </div>
</mat-menu>
